var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29H3.5C2.68 29 2 28.32 2 27.5V11.5C2 6.26 6.26 2 11.5 2H29.5C30.32 2 31 2.68 31 3.5V23.5C31 26.54 28.54 29 25.5 29ZM5 26H25.5C26.88 26 28 24.88 28 23.5V5H11.5C7.92 5 5 7.92 5 11.5V26Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 45C12.46 45 10 42.54 10 39.5C10 36.46 12.46 34 15.5 34C18.54 34 21 36.46 21 39.5C21 42.54 18.54 45 15.5 45ZM15.5 37C14.12 37 13 38.12 13 39.5C13 40.88 14.12 42 15.5 42C16.88 42 18 40.88 18 39.5C18 38.12 16.88 37 15.5 37Z",
    fill: "#03182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 45C28.46 45 26 42.54 26 39.5C26 36.46 28.46 34 31.5 34C34.54 34 37 36.46 37 39.5C37 42.54 34.54 45 31.5 45ZM31.5 37C30.12 37 29 38.12 29 39.5C29 40.88 30.12 42 31.5 42C32.88 42 34 40.88 34 39.5C34 38.12 32.88 37 31.5 37Z",
    fill: "#03182F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 22.76L41.38 16.76L37.96 10.78C36.98 9.06 35.16 8 33.18 8H29.5C28.68 8 28 8.68 28 9.5V23.5C28 24.88 26.88 26 25.5 26H3.5C2.68 26 2 26.68 2 27.5V33.5C2 37.64 5.36 41 9.5 41H11.5C12.32 41 13 40.32 13 39.5C13 38.12 14.12 37 15.5 37C16.88 37 18 38.12 18 39.5C18 40.32 18.68 41 19.5 41H27.5C28.32 41 29 40.32 29 39.5C29 38.12 30.12 37 31.5 37C32.88 37 34 38.12 34 39.5C34 40.32 34.68 41 35.5 41H37.5C41.64 41 45 37.64 45 33.5V23.5C45 23.24 44.92 22.98 44.8 22.76ZM42 23.9V33.5C42 35.98 39.98 38 37.5 38H36.8C36.14 35.7 34.04 34 31.52 34C29 34 26.88 35.7 26.22 38H20.8C20.14 35.7 18.02 34 15.5 34C12.98 34 10.86 35.7 10.2 38H9.5C7.02 38 5 35.98 5 33.5V29H25.5C28.54 29 31 26.54 31 23.5V11H33.18C34.08 11 34.92 11.48 35.36 12.26L42 23.9V33.5V23.9Z",
    fill: "#03182F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8C17.32 8 18 8.68 18 9.5V20.5C18 21.32 17.32 22 16.5 22C15.68 22 15 21.32 15 20.5V9.5C15 8.68 15.68 8 16.5 8Z",
    fill: "#FF2B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 15C23.5 15.82 22.82 16.5 22 16.5H11C10.18 16.5 9.5 15.82 9.5 15C9.5 14.18 10.18 13.5 11 13.5H22C22.82 13.5 23.5 14.18 23.5 15Z",
    fill: "#FF2B26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.54a7702c59abdb69fab0da1685879f51.svg";
export { ForwardRef as ReactComponent };